module.exports = __webpack_public_path__ + "img/14_maska_shesterenka.30c9696.svg";